import React from "react";
import { Form, Input } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import { Award, Briefcase, Mail, Phone, UserPlus } from "lucide-react";
import TextArea from "antd/es/input/TextArea";


const ClientReferralForm = ({ form }) => {
  return (
      <Form
        className="form"
        layout="vertical"
        form={form}
      >
        <div className="w-full">
          <FormItem
            className="font-medium mb-2"
            name="name"
            label="Contact Name"
          >
            <Input
              placeholder="Enter client contact name"
              className="input-field"
            />
          </FormItem>

          <FormItem
            className="font-medium mb-2"
            name="email"
            label="Email"
          >
            <Input
              placeholder="contact@company.com"
              className="input-field"
              prefix={<Mail className="w-4 h-4 text-gray-600"/>}
            />
          </FormItem>

          <FormItem
            className="font-medium mb-2"
            name="phone"
            label="Phone"
          >
            <Input
              placeholder="+1 (555) 000-0000"
              className="input-field"
              prefix={<Phone className="w-4 h-4 text-gray-600"/>}
            />
          </FormItem>

          <FormItem
            className="font-medium mb-2"
            name="company"
            label="Company Name"
          >
            <Input
              placeholder="e.g., Tech Solutions Inc."
              className="input-field"
              prefix={<Briefcase className="w-4 h-4 text-gray-600"/>}
            />
          </FormItem>

          <FormItem
            className="font-medium mb-2"
            name="industry"
            label="Industry"
          >
            <Input
              className="input-field"
              placeholder="e.g., Technology, Healthcare, Finance"
            />
          </FormItem>

          <FormItem
            className="font-medium mb-3"
            name="notes"
            label="Additional Notes (Optional)"
          >
            <TextArea
              id=""
              className="input-field"
              maxLength={255}
              placeholder="Tell us about their business needs or challenges..."
            />
          </FormItem>
        </div>
        <button 
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all mb-2
           shrink-0 h-9 px-4 py-2 w-full bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white">
          <UserPlus className="w-4 h-4"/> Submit Client Referral
        </button>
        <div className="flex items-start gap-2 p-3 rounded-xl bg-emerald-50 border border-emerald-200">
          <Award className="w-4 h-4 text-emerald-600"/>
          <p className="text-[11px] text-emerald-800 leading-relaxed">
            Earn <span className="font-semibold">Hyvid Points</span> for every client referral that leads to a successful partnership
          </p>
        </div>
      </Form>
 

  );
};
export default ClientReferralForm;